/*
    Объекты, появляющиеся при скролле
*/

import { FadeInImage } from './FadeInImage.js';


let lazy;


class LazyLoad {
    constructor() {
        this.smController;
        this.selectors = '[data-lazy-src], [data-lazy-bg], .js-slider, .js-hover-previews';

        this.init();
    }


    // Следим за скроллом
    init() {
        const offset = App.W.height() * -1;

        this.smController = new ScrollMagic.Controller({
            globalSceneOptions: {
                // верхняя точка срабатывания
                offset: offset,
                // нижняя точка (важна для своевременного
                // срабатывания при скролле снизу вверх)
                duration: '300%',
            }
        });

        App.H.find(this.selectors).each((i, el) => {
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 'onEnter'
            })
                // .addIndicators()
                .addTo(this.smController)
                .on('enter', () => {
                    this.load(el);
                });
        });
    }


    // Подставляем URL
    load(el) {
        const $el = $(el);

        // Повторно не грузим
        if ($el.is('._lazy-detected, ._loaded')) {
            return;
        }

        // Не грузим на мобильных, если не надо
        if ($el.is('[data-lazy-nomobile]') && App.mobile) {
            return;
        }

        // Маркируем, что уже загружаем
        $el.addClass('_lazy-detected');

        // <img>
        if ($el.is('[data-lazy-src]')) {
            $el.attr('src', $el.data('lazy-src'));
        }

        // background-image
        if ($el.is('[data-lazy-bg]')) {
            $el.css({
                'background-image': `url(${ $el.data('lazy-bg') })`
            });

            if ( $el.is('[data-fadein]') ) {
                // Плавное появление картинки
                new FadeInImage(el);
            }
        }

        // Слайдер (просто триггерим для него событие)
        $el.trigger('lazyload:start');

        // Превью ссылок по ховеру
        if ( $el.is('.js-hover-previews') && !App.mobile) {
            $el.find('[data-img-hover]').each(function() {
                const url = $(this).data('img-hover');
                $(this)
                    .parent()
                    .append(`<div class="hover-preview" style="background-image: url(${url})"></div>`);
            });
        }
    }


    destroy() {
        try {
            this.smController = this.smController.destroy(true);
        } catch (error) { }
    }
}



App.W.on('barba:afterEnter', () => {
    lazy = new LazyLoad();
});

App.W.on('barba:leave', () => {
    try {
        lazy.destroy();
    } catch (error) { }
});



// WEBPACK FOOTER //
// ./_src/js/modules/LazyLoad.js